// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2hSTV","icon":"style_icon__3owoA","badge":"style_badge__cBnkj"};